import { initEcho } from '@/core/echo';
import EventBus from '@/core/shared/services/EventBus';
import moment from 'moment-timezone';
import { initLaunchDarkly } from '@/core/shared/setup/launchDarkly';
import { initSBVRPermissions } from '@/core/shared/setup/permissions';

export const initUser = async ({ commit, dispatch, rootGetters, rootState }) => {
  const organization = await dispatch('getOrganizationBasics', 'isActive');

  if (organization.type === 'developer') {
    commit('setFlash', {
      type: 'error',
      message: 'You are not an Operator',
    });
    dispatch('logout');
  }

  commit('setOrgActiveFlag', organization.isActive);

  const locations = await dispatch('getLocations');
  const user = rootGetters.currentUser;

  if (locations.length > 0) dispatch('setLocationHeader');

  const locationId = rootState.route.params && rootState.route.params.locationId;
  const hasObsoleteId = locationId && locations.every(({ id }) => locationId !== id);

  if (locations.length === 0) {
    EventBus.$emit('router:push', { name: 'no-location' });
  } else if (!rootState.route.name || rootState.route.name === 'login' || hasObsoleteId) {
    EventBus.$emit('router:push', { name: 'overview', params: { locationId: locations[0].id } });
  }

  initLaunchDarkly(user, organization);
  initSBVRPermissions(user, organization);
  initEcho(user.pusherConfiguration, rootState.auth.token);
};

export const setLocationHeader = async ({ rootGetters, commit }) => {
  const locations = rootGetters['entities/Location/all']()
    .sort((a, b) => {
      const aTitle = a.title.toLowerCase();
      const bTitle = b.title.toLowerCase();
      if (aTitle < bTitle) return -1;
      if (aTitle > bTitle) return 1;
      return 0;
    })
    .map(location => ({
      name: location.title,
      locationId: location.id,
    }));
  commit('setTitle', locations);
};

export const cleanUpUser = () => {
  window.echo = null;
};

export const getCurrentTime = async ({ state, commit }) => {
  const beforeQuery = new Date().getTime();
  const data = await fetch('https://current-time.springboardvr.com').then(res => res.json());

  const afterQuery = new Date().getTime();

  const currentTime = moment(data.currentTime).add(afterQuery - beforeQuery, 'milliseconds').format();
  commit('setCurrentTime', currentTime);
};
